export default "__VITE_ASSET__MXnL5XbG__"